// IMPORTS
//-------------------------------------------------------------------------------------------------------------------------
//Angular
import { Injectable } from '@angular/core';

//import { WebServices } from '../../shared/services/webServices';
import { appConfig } from '../../shared/appConfig.js';

//Third Party
//import moment from 'moment';


// EXPORTS
//-------------------------------------------------------------------------------------------------------------------------
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Helpers
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
@Injectable()
export class Helpers {

    // INITIALIZATION
    //-------------------------------------------------------------------------------------------------------------------------
    //==================================
    // constructor
    //==================================
    constructor(){};


    // GENERIC HELPERS
    //-------------------------------------------------------------------------------------------------------------------------
    //================================================
    // coalesce
    //================================================
    //  Returns the first defined, non-null value or null
    coalesce() {
        var len = arguments.length;
        for (var i=0; i<len; i++) {
            if (!this.isNullOrUndefined(arguments[i])){
                return arguments[i];
            }
        }
        return null;
    };


    //================================================
    // deepCopyObject
    //================================================
    // Can be used to deep copy and object or array
    deepCopyObject(obj) {

        let res = null;
        let key;
        let val;

        //Apply value types and terminate recursion
        if (typeof obj !== "object" || obj === null) {
            return obj;
        }

        //Create an array or object to hold the values
        res = Array.isArray(obj) ? [] : {};

        for (key in obj) {

            val = obj[key];

            //Recurse for deep copy
            res[key] = this.deepCopyObject(val);
        }

        return res;
    }



    //==================================
    // executeOnCondition
    //==================================
    // A method for waiting asynchronously for a condition to occur before executing a function
    // NOTE: There is an emergency shutoff after 10 seconds.  This method is not intended
    //          to be used as a long term process, but to gap those undetermined, but short
    //          time spans between the time you ask Angular to do something and when it actually 
    //          gets it done.
    //
    //  fnCondition<fn>:    (req) When this function returns true, the fnExecute function will be called
    //  fnExecute<fn>:      (req) Method to execute when the condition is met
    //  delay<int>:         (opt, def:100, no 0's) Milliseconds between condition tests
    //  tries<int>:         (opt, def:10, no 0's) Number of times to try the condition before giving up
    executeOnCondition(fnCondition, fnExecute, delay, tries) {

        //Try right off to see if the condition is laready met        
        if (fnCondition()) {
            fnExecute();
            return;
        }

        //Default the params
        delay = delay || 100;
        tries = tries || 1;

        //Set up the evaluation intervals
        var id = setInterval(() => {

            //Run execute fn and jump out if we have meet the condition
            if (fnCondition()) {
                fnExecute();
                clearInterval(id);
                return;
            }

            //Condition not met, but no more tries allowed
            if (--tries < 1) {
                clearInterval(id);
                return;
            }

        }, delay);
        
        // Emergency shutoff
        setTimeout(() => {
            clearInterval(id); //Does nothing if already cleared
        }, 10000);

    }

    //Don't us this one.  Use the one in cpd-formatters
    ////================================================
    //// formatDate
    ////================================================
    //// This is a very simple, "no frills" formatter that uses only javascript
    //formatDate(jsDate){
    //    return (jsDate.getMonth() + 1) + "/" + jsDate.getDate() + "/" + jsDate.getFullYear();
    //};

    //================================================
    // getFirstNonBlank
    //================================================
    //  Same as _coalesce but counts blank strings as empty
    getFirstNonBlank() {
        var len = arguments.length;
        for (var i=0; i<len; i++) {
            if (!_isBlank(arguments[i])){
                return arguments[i];
            }
        }
        return null;
    };
    
    //================================================
    // isBlank
    //================================================
    //  Returns true for values that are null, undefined, or a blank string.
    //  All other values will return a false (including 0)
	isBlank(val) {
        return typeof (val) === "undefined" || val === null || val === "";
	};

    //================================================
    // isEmpty
    //================================================
    //  Returns true for values that are null or undefined.
    //  All other values will return a false (including "" and 0)
    // Note: This method is a little confusing, so I added a new one below thats a little clearer: isNullOrUndefined
	isEmpty(val) {
        return val === typeof (val) === "undefined" || null;
	};

    //================================================
    // isFunction
    //================================================
    isFunction(val) {
        return this.isEmpty(val) ? false : typeof val === "function";
    }

    //================================================
    // isNullOrUndefined
    //================================================
    //  Returns true for values that are null or undefined.
    //  All other values will return a false (including "" and 0)
	isNullOrUndefined(val) {
        return (typeof (val) === "undefined" || val === null) ? true : false;
    };

    //============================================
    // isValidEmailAddress
    //============================================
    isValidEmailAddress(emailToValidate) {
        return emailToValidate.match(
            /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    };

    //==================================
    // markAngularFormDirty
    //==================================
    //Sometimes, you want to force a form to validate when no fields have actually been touched.
    //For example, when someone clicks a save button, but field errors will prevent the save from working.
    //Note: This is shallow as written nd will not dive into subforms
    markAngularFormDirty(form) {

        //Is this the form we expect?
        if (!form.markAsTouched) { throw "[markAngularFormDirty] Unrecognized form object"; }

        //Mark the form
        form.markAsTouched();
        form.markAsDirty();

        //Mark the controls (still have to do this by hand in Angular 5)
        let controlNames = Object.keys(form.controls); //IE compatile way to iterate object properties (not sure when we should drop support)
        controlNames.map((controlName) => {

            let control = form.controls[controlName];
        
            if (control.markAsTouched && typeof control.markAsTouched == "function") {
                control.markAsTouched();
            }

            if (control.markAsDirty && typeof control.markAsDirty == "function") {
                control.markAsDirty();
            }
        });
    }

    //================================================
    // objectArrayToObject
    //================================================
    // Takes an array of objects, where one of the properties on each object is a unique identifier
    // and returns a single object where the properties are those ids and the value is the original object.
    //
    //  example:
    //
    //  var objs = [ {id:1, text:"One"}, {id:2, text:"Two"}, {id:3, text:"Three"}];
    //
    //  var newObj = objectArrayToObject(objs, "id");
    //
    //  newObject = 
    //      1: { id: 1, text: "One" }
    //      2: { id: 2, text: "Two" }
    //      3: { id: 3, text: "Three" }
    //
    objectArrayToObject(array, keyField) {

        return array.reduce((obj, item) => {
            obj[item[keyField]] = item
            return obj
        }, {});
    }

    //================================================
    // objectToArray
    //================================================
    //Take the value of each property of an object pushes it into an array
    //This uses Object.keys.  May need to use an alternative if supporting older browsers
    //(This is antiquated.  Use Object.keys() or Object.values() instead
    objectToArray(obj){
        return Object.keys(obj).map((k)=>{ return obj[k]; });
    }

    //==================================
    // _stripHTML
    //==================================
    // Basic HTML stripper
    stripHTML(str){
        return str.replace(/<(?:.|\n)*?>/gm, '');
    };

    //================================================
    // stringToBoolean
    //================================================
    // This is a little more robust than the string extension version
    stringToBoolean(s) {

        //Kick nulls, undefineds, and all defualt false equivalents out as false
        if (!s) { return false; }

        //Check to see if this object has toUpperCase
        if (s.toUpperCase) {
            switch (s.toUpperCase()) {
                case "Y":
                case "T":
                case "TRUE":
                case "1":
                    return true;
            }
        }

        return false;
    }

    //================================================
    // truncateString
    //================================================
    truncateString(val, maxLen){
        return val.length <= maxLen ? val : val.substr(0, maxLen-3) + "...";
    };

    //==================================
    // _waffleFocus
    //==================================
    waffleFocus() {

        //console.log("_waffleFocus()");

        //This method is to avoid having to catch every keypress on all editable elements to track changes
        //without requireing the user to tab away from an edited element.  This is needed for a 508 issue triggered
        //when a Jaws user presses a shortcut key to save a page where the only change is in the current element.

        //Save the current element with the focus
        var elOrig = document.activeElement;

        //Create a temporary tabbable element offscreen
        var el = document.createElement("input");
        el.style.cssText = "position:absolute;left:-5000px";
        document.body.appendChild(el);

        //Change the focus to the off screen element (to trigger an element changed event)
        el.focus();

        //Reset the focus to the original element (give the browser time to render)
        setTimeout(() => { elOrig.focus(); }, 0);

        //Remove the temporary element
        el.parentNode.removeChild(el);
    };

    //==================================
    // waitFor
    //==================================
    //Promise based version of executeOnCondition()
    //Untested and currently unused
    //async waitFor(fnCondition, delay, tries) {

    //    //Default the params
    //    delay = delay || 100;
    //    tries = tries || 1;

    //     return await new Promise(resolve => {

    //        const id = setInterval(() => {

    //            console.log("tick"); 

    //            if (fnCondition()) {
    //                resolve("success");
    //                clearInterval(id);
    //            }
    //            else  if (--tries < 1) {
    //                clearInterval(id);
    //                resolve("failed");
    //            }

    //        }, delay);

    //     });
    //}
    

    // CPDES BL HELPERS
    //-------------------------------------------------------------------------------------------------------------------------
    //============================================
    // containsFlag
    //============================================
    /// <summary>
    /// Helper method for those unfamiliar with bit flags
    /// Parameters: long flag, ATCFlags ATCFlag
    /// </summary>
    containsFlag(flags, ATCFlag) {
        return (flags & ATCFlag) != 0;
    }

    //================================================
    // getFY
    //================================================
    // Returns the current FY
    getFY(){

        return appConfig.CURRENT_FY();

        //This is no longer valid since the dates are now in the rollover execution table
        ////Default the fromDate arg if needed
        //let _fromDate = !fromDate ? new Date() : fromDate;

        ////Is the passed in value a date? (yeah I know, but it'll work fine for our purposes)
        //if (!_fromDate.getMonth) {

        //    //NOT A DATE OBJECT, try to convert
        //    try {
        //        _fromDate = new Date(fromDate);
        //        if (isNaN(_fromDate)){ throw ("Bad date string"); }
        //    }
        //    catch (e) {
        //        //console.log("[helpers.js:getFY()] Argument provided could not be converted to a date. fromDate:", fromDate);
        //        throw ("[helpers.js:getFY()] Argument provided could not be converted to a date. fromDate: " + fromDate);
        //    }
        //}
        //else {
        //    //DATE OBJECT, copy
        //    _fromDate = new Date(_fromDate.getTime());
        //}

        //var curMonth = _fromDate.getMonth();     //0-indexed!
        //var october = 9;                        //0-indexed

        //return curMonth < october ? _fromDate.getFullYear() : _fromDate.getFullYear() + 1;
    };
    
}
